define("shared/components/shared/post/secondary/hashtag-suggestions/auto", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/service", "@ember/runloop", "lodash", "shared/utils/get-hashtags"], function (_exports, _component, _templateFactory, _component2, _tracking, _service, _runloop, _lodash, _getHashtags) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _setSideModalLoading;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/service",0,"@ember/runloop",0,"lodash",0,"shared/utils/get-hashtags",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="u--p__lr__lg u--m__0" {{track "clicked-beta-caption-hashtag-suggestions" "click"}}>
    <p>
      {{t "hashtag_suggestions.auto.description"}}
    </p>
  </div>
  
  {{#if this.showCalculatingAnimation}}
    <Shared::Ui::CalculatingState
      @text={{t "hashtag_suggestions.loading"}}
      class="u--text--uppercase"
    />
  {{else if this.showCaptionHashtags}}
    <hr class="u--m__tb__0">
    <Shared::Post::Secondary::HashtagSuggestions::Table
      @selectedHashtags={{@selectedHashtags}}
      @suggestedHashtags={{this.uniqueCaptionHashtags}}
      @selectHashtag={{@selectHashtag}}
    />
  {{else if this.showNoCaptionState}}
    <Shared::Post::Secondary::HashtagSuggestions::NoCaption/>
  {{else if this.isError}}
    <Shared::Post::Secondary::HashtagSuggestions::Error @hashtagQuery={{null}} @isSearch={{false}}/>
  {{else if this.showEmptyState}}
    <Shared::Post::Secondary::HashtagSuggestions::Empty @suggestedHashtags={{@uniqueCaptionHashtags}} @isSearch={{false}}/>
  {{/if}}
  */
  {
    "id": "dmHjWt9l",
    "block": "[[[11,0],[24,0,\"u--p__lr__lg u--m__0\"],[4,[38,0],[\"clicked-beta-caption-hashtag-suggestions\",\"click\"],null],[12],[1,\"\\n  \"],[10,2],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"hashtag_suggestions.auto.description\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showCalculatingAnimation\"]],[[[1,\"  \"],[8,[39,3],[[24,0,\"u--text--uppercase\"]],[[\"@text\"],[[28,[37,1],[\"hashtag_suggestions.loading\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCaptionHashtags\"]],[[[1,\"  \"],[10,\"hr\"],[14,0,\"u--m__tb__0\"],[12],[13],[1,\"\\n  \"],[8,[39,4],null,[[\"@selectedHashtags\",\"@suggestedHashtags\",\"@selectHashtag\"],[[30,1],[30,0,[\"uniqueCaptionHashtags\"]],[30,2]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showNoCaptionState\"]],[[[1,\"  \"],[8,[39,5],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isError\"]],[[[1,\"  \"],[8,[39,6],null,[[\"@hashtagQuery\",\"@isSearch\"],[null,false]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showEmptyState\"]],[[[1,\"  \"],[8,[39,7],null,[[\"@suggestedHashtags\",\"@isSearch\"],[[30,3],false]],null],[1,\"\\n\"]],[]],null]],[]]]],[]]]],[]]]],[]]]],[\"@selectedHashtags\",\"@selectHashtag\",\"@uniqueCaptionHashtags\"],false,[\"track\",\"t\",\"if\",\"shared/ui/calculating-state\",\"shared/post/secondary/hashtag-suggestions/table\",\"shared/post/secondary/hashtag-suggestions/no-caption\",\"shared/post/secondary/hashtag-suggestions/error\",\"shared/post/secondary/hashtag-suggestions/empty\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/auto.hbs",
    "isStrictMode": false
  });

  let AutoComponent = (_dec = (0, _service.inject)('schedule/caption-hashtags'), (_class = (_setSideModalLoading = /*#__PURE__*/new WeakSet(), class AutoComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _setSideModalLoading);

      _initializerDefineProperty(this, "scheduleCaptionHashtags", _descriptor, this);

      _initializerDefineProperty(this, "showSideModalLoading", _descriptor2, this);

      _classPrivateMethodGet(this, _setSideModalLoading, _setSideModalLoading2).call(this);
    }

    get uniqueCaptionHashtags() {
      return this.args.captionHashtags.filter(_ref2 => {
        let {
          hashtag
        } = _ref2;
        return !this.usedHashtags.includes(hashtag);
      });
    }

    get usedHashtags() {
      return (0, _getHashtags.default)(this.args.currentText);
    }

    get showCalculatingAnimation() {
      return this.showSideModalLoading || this.scheduleCaptionHashtags.isLoading;
    }

    get showCaptionHashtags() {
      return !this.showCalculatingAnimation && !this.showNoCaptionState && !this.showEmptyState && !this.isError;
    }

    get showNoCaptionState() {
      return !this.args.currentText.split(' ').filter(word => word !== '').length;
    }

    get showEmptyState() {
      return (0, _lodash.isEmpty)(this.uniqueCaptionHashtags);
    }

    get isError() {
      return this.scheduleCaptionHashtags.error !== null;
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "scheduleCaptionHashtags", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showSideModalLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class));
  _exports.default = AutoComponent;

  function _setSideModalLoading2() {
    this.showSideModalLoading = true;
    (0, _runloop.later)(() => {
      this.showSideModalLoading = false;
    }, 300);
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AutoComponent);
});